<template>
  <div>
    <b-row>
      <b-col>
        <h1 class="tsny_header section_header text-center mb-5">
          {{ displayName || name }}
        </h1>
      </b-col> </b-row
    ><b-row class="mb-5"
      ><b-col
        ><b-table
          class="tsny_text-mid text-center"
          borderless
          :items="formattedItems"
          :fields="fields"
          thead-tr-class="tsny_table-head"
          tbody-tr-class="tsny_table-body"
        >
          <template v-slot:cell(section)="data">
            <span class="text-dark font-weight-bold">{{ data.value }}</span>
          </template>
          <template v-slot:cell(scaledScore)="data">
            <span :style="{ color: color }">{{ data.value }}</span>
          </template>
        </b-table></b-col
      ></b-row
    >
    <b-row
      ><b-col>
        <breakdown
          v-for="subsection in subSections"
          :id="
            subsection.name === 'No Calculator'
              ? 'noCalculator'
              : subsection.name
          "
          :key="subsection.name"
          :name="subsection.name"
          :breakdown="subsection.subSection"
        /> </b-col
    ></b-row>
  </div>
</template>

<script>
import { _ } from "vue-underscore";
import Breakdown from "../Breakdown";

export default {
  name: "SectionBreakdown",
  components: { Breakdown },
  props: {
    section: {
      type: Object,
      default: null
    },
    color: {
      type: String,
      default: null
    },
    name: {
      type: String,
      default: null
    },
    displayName: {
      type: String,
      default: null
    }
  },
  computed: {
    formattedItems() {
      return _.keys(this.section.subSections).map(key => ({
        section: key,
        ...this.section.subSections[key]
      }));
    },
    subSections() {
      return _.keys(this.section.subSections).map(key => ({
        name: key,
        subSection: this.section.subSections[key]
      }));
    }
  },
  data: () => ({
    fields: [
      { key: "section" },
      { key: "correct" },
      { key: "incorrect" },
      { key: "omitted" },
      { key: "total" }
    ]
  }),
  mounted() {
    if (this.name === "Verbal") {
      this.fields.push({ key: "scaledScore", label: "Score (10-40)" });
    }
  }
};
</script>

<style scoped>
.section_header {
  font-size: 2.5em;
}
</style>
